import React, { useEffect } from 'react';

export const useRoute = ({ history }) => {
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.trigger('router.ready', {});
    window.LIFE_CYCLE_EVENT_BUS.trigger('router.change', {
      location: history.location
    });
    return history.listen((location, action) => {
      const opts = {
        location,
        action,
      };
      window.LIFE_CYCLE_EVENT_BUS.trigger('router.change', opts);
    }, 0);
  }, []);
};
